import React, { useState, useEffect } from "react";
import { Collapse, Card, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const AiOverviewSection = ({
  isOpen,
  onToggle,
  initialKeyword = "",
  initialFormData = null,
  onSubmit,
  isLoading = false,
  isAnyLoading = false
}) => {
  const [keyword, setKeyword] = useState(initialFormData?.keyword || initialKeyword);
  const [brand, setBrand] = useState(initialFormData?.brand || "");
  const [noQueries, setNoQueries] = useState(initialFormData?.noQueries || 10);

  useEffect(() => {
    setKeyword(initialKeyword);
  }, [initialKeyword]);

  useEffect(() => {
    if (initialFormData) {
      setKeyword(initialFormData.keyword || initialKeyword);
      setBrand(initialFormData.brand || "");
      setNoQueries(initialFormData.noQueries || 10);
    }
  }, [initialFormData, initialKeyword]);

  const handleSubmit = () => {
    if (!keyword.trim()) return;
    
    onSubmit({
      keyword: keyword.trim(),
      brand: brand.trim(),
      noQueries: noQueries
    });
  };

  const handleReset = () => {
    setBrand("");
    setNoQueries(10);
  };

  return (
    <div className="mb-3">
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-white border-0 p-0">
          <Button
            className="w-100 text-start border-0 bg-transparent text-dark d-flex align-items-center justify-content-between p-3"
            onClick={onToggle}
            aria-controls="collapse-ai-overview"
            aria-expanded={isOpen}
            style={{ cursor: 'pointer' }}
          >
            <div className="d-flex align-items-center">
              <FontAwesomeIcon
                icon={isOpen ? faChevronDown : faChevronRight}
                className="me-3 text-primary"
              />
              <div>
                <div className="fw-bold">AI Overview</div>
                <small className="text-muted">Generate AI-powered keyword insights and recommendations</small>
              </div>
            </div>
          </Button>
        </Card.Header>
        <Collapse in={isOpen}>
          <div id="collapse-ai-overview">
            <Card.Body className="pt-0">
              <p className="text-muted small mb-3">
                Generate comprehensive AI-powered overviews for any keyword and brand combination, 
                providing strategic insights and actionable recommendations.
              </p>
              
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">Keyword</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter keyword"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    size="sm"
                  />
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">Brand Name (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter brand name"
                    value={brand}
                    onChange={(e) => setBrand(e.target.value)}
                    size="sm"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold">Number of Queries</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="10"
                    value={noQueries}
                    onChange={(e) => setNoQueries(parseInt(e.target.value) || 10)}
                    size="sm"
                    min="1"
                    max="50"
                  />
                </Form.Group>
                
                <div className="row g-2">
                  <div className="col-8">
                    <div className="d-grid">
                      <Button
                        variant="info"
                        size="sm"
                        onClick={handleSubmit}
                        disabled={!keyword.trim() || isAnyLoading}
                        style={{
                          cursor: (!keyword.trim() || isAnyLoading) ? 'not-allowed' : 'pointer',
                          opacity: (!keyword.trim() || isAnyLoading) ? 0.7 : 1,
                          backgroundColor: (!keyword.trim() || isAnyLoading) ? '#6c757d' : '',
                          borderColor: (!keyword.trim() || isAnyLoading) ? '#6c757d' : '',
                          color: (!keyword.trim() || isAnyLoading) ? '#ffffff' : ''
                        }}
                      >
                        {isLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Generating...
                          </>
                        ) : (
                          "Generate AI Overview"
                        )}
                      </Button>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="d-grid">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={handleReset}
                        disabled={isAnyLoading || (!brand.trim() && noQueries === 10)}
                        style={{
                          cursor: (isAnyLoading || (!brand.trim() && noQueries === 10)) ? 'not-allowed' : 'pointer',
                          opacity: (isAnyLoading || (!brand.trim() && noQueries === 10)) ? 0.7 : 1,
                          backgroundColor: (isAnyLoading || (!brand.trim() && noQueries === 10)) ? '#f8f9fa' : '',
                          borderColor: (isAnyLoading || (!brand.trim() && noQueries === 10)) ? '#6c757d' : '',
                          color: (isAnyLoading || (!brand.trim() && noQueries === 10)) ? '#6c757d' : ''
                        }}
                      >
                        Reset
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            </Card.Body>
          </div>
        </Collapse>
      </Card>
    </div>
  );
};

export default AiOverviewSection;
